import { apiSlice } from 'store/slices/api';
import { URLS } from 'store/slices/constants/apiV1';
import { BRANDFETCH_CLIENT_ID } from 'constants/envConstants';
import { BrandfetchSearchResponse } from 'types';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

export const brandfetchApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    searchBrands: builder.query<BrandfetchSearchResponse, string>({
      queryFn: async (name) => {
        const url = URLS.BRANDFETCH_SEARCH(name, BRANDFETCH_CLIENT_ID);
        try {
          const response = await fetch(url);
          if (!response.ok) {
            return {
              error: {
                status: response.status,
                data: await response.text(),
              } as FetchBaseQueryError,
            };
          }
          const data = await response.json();
          return { data };
        } catch (error) {
          return {
            error: {
              status: 'FETCH_ERROR',
              error: String(error),
            } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const { useLazySearchBrandsQuery, useSearchBrandsQuery } =
  brandfetchApiSlice;
